// import styles from "./styles.module.scss"
import { Layout } from "./../../components";

export default function Home() {
  return <Layout>Layout</Layout>;
}
